'use client';

import Box from '@mui/material/Box';
import { CircularProgress } from '@mui/material';

// const metadata = { title: `${config?.site?.name}` };

export function LoadingPage() {

  return (
    <Box
    sx={{
        maxWidth: 'var(--Content-maxWidth)',
        m: 'var(--Content-margin)',
        p: 'var(--Content-padding)',
        width: 'var(--Content-width)',
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100%',
        minHeight: '80vh'
    }}
    >
      <CircularProgress />
    </Box>
  );
}
